import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { isAndroid, isIos, inWeixin } from 'web-launch-app';
import styles from './index.module.less';
import { useDocumentTitle } from "~src/hooks/useDocumentTitle"
import { createSearchParams } from "react-router-dom";
import { Toast } from "antd-mobile/2x";
import { getAppLink } from "~src/service/app_download/index";
import { VersionResponse } from "~src/service/app_download/version";
import Dot from "~src/constants/svgs/dot";

export default React.memo(() => {
  const [visible, setVisible] = useState<boolean>(false);
  const [appPath, setAppPath] = useState<string>("");
  const [androidAppInfo, setAndroidAppInfo] = useState<VersionResponse>();

  useDocumentTitle("下载");

  useEffect(() => {
    if (!inWeixin) {
      const data = createSearchParams(window.location.search.split("?")[1] || "") || {};
      const path = data.get("appPath") ?? ""; // lvmio://app.com/
      setAppPath(path);
      if (path) {
        const isSafari = window.navigator.userAgent.includes("Safari");
        const isChrome = window.navigator.userAgent.includes("Chrome");
        const iosVersion = window.navigator.userAgent.includes("Version");
        const iPhone = window.navigator.userAgent.includes("iPhone");
        if (isSafari && iPhone && iosVersion) {
          const isDev = window.location.href.includes("dev");
          window.location.replace(`https://go${isDev ? "dev" : ""}-api.miotech.com/app/` + path.replace("lvmio://app.com/", ""));
        } else if (!(isChrome && isAndroid)) {
          // 安卓的谷歌浏览器不做自动跳转
          setTimeout(() => {
            window.location.href = path;
          }, 500)
        }
      }
    }

    if(inWeixin) {
      setVisible(true)
    }

    getVersion();
  }, [])

  const getVersion = async () => {
    const result = await getAppLink();
    setAndroidAppInfo(result);
  }

  const onDownLoad = () => {
    if (inWeixin) {
      return;
    }
    const inLvmio = !!window.flutter_inappwebview;
    const lvmioBridge = window.flutter_inappwebview;

    try {
      const androidLink = androidAppInfo?.turnLink || androidAppInfo?.downLink || "";
      const link = isIos ? "https://itunes.apple.com/cn/app/id6448589841?mt=8" : androidLink;
      if (inLvmio && isAndroid) {
        Toast.show({ content: "即将在浏览器中打开" });
        lvmioBridge.callHandler("openBrower", link);
        return;
      }
      if (isAndroid && appPath) {
        window.location.href = appPath;
        // 延迟下载
        setTimeout(() => {
          if (document.visibilityState == "visible") {
            (window?.top ?? window).location.href = link;
          }
        }, 2000);
      } else {
        (window?.top ?? window).location.href = link;
      }
    } catch (e) { }
  }

  return <div className={styles.container}>
    {
      visible ? <div className={styles.tips}>
        <div className={styles.direction}></div>
        <div>
          <div className={styles.text}>
            1.点击右上角
            <div className={styles.dot}>
              <Dot />
            </div>
          </div>
          <div className={styles.text}>
            2.选择浏览器中打开
          </div>
        </div>
      </div> : null
    }
    <div className={styles.content}>
      {isIos && <div className={classNames(styles.button, styles.ios)} onClick={onDownLoad}>立即下载</div>}
      {isAndroid && <div className={classNames(styles.button, styles.android)} onClick={onDownLoad}>立即下载</div>}
      {isAndroid && <div className={styles.version}>最新版本 {androidAppInfo?.version}</div>}
    </div>
  </div>
});
